// extracted by mini-css-extract-plugin
module.exports = {"hover":"AvatarUser_hover__3m6gA"};